














import { Mixins, Component, Prop, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import ReceptionDialogSelector from "../../selectors/ReceptionDialogSelector.vue";
import { Department } from "../../../../domain/department";
import { DepartmentListSelectorDialog, IDepartmentListSelectorDialogCondition } from "../../../department/dialogs";

@Component({
  components: {
    ReceptionDialogSelector,
  }
})
export default class ReceptionDetailDepartmentEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  nonDisplayDepartmentCodes: string[];

  @Emit()
  updateDepartment(): void {}

  get departmentSelectDialog(): DepartmentListSelectorDialog {
    return this.$commonDialogs.department.listSelector;
  }

  get departmentSelectDialogCondition(): IDepartmentListSelectorDialogCondition {
    return {
      name: this.$wording.common.department,
      nonDisplayDepartmentCodes: this.nonDisplayDepartmentCodes ? this.nonDisplayDepartmentCodes : null,
    };
  }

  departmentSelector: ReceptionDialogSelector;
  
  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.departmentSelector = this.$refs.departmentSelector as ReceptionDialogSelector;
  }

  get department(): Department {
    return this.readPropertyOrDefault(d => d.department, null);
  }

  set department(value: Department) {
    this.writeProperty(d => d.department = value);
    this.updateDepartment();
  }

  selectDepartment(): void {
    this.departmentSelector.select();
  }
}
